import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { CompanyContact, ContactSubscription, ContactTag } from '../../models/Contact';

export interface CompanyContactsResponse {
  contacts: CompanyContact[];
  // Only on the first page: the subscriptions read and the tags they can carry
  tags?: ContactTag[];
  subscriptions?: ContactSubscription[];
  // Last contact id of each subscription that still has contacts, null once they are all exhausted
  next_cursors: Record<string, string> | null;
}

interface GetCompanyContactsPayload {
  company_id: string;
  cursors?: Record<string, string>;
}

export async function getCompanyContacts(
  payload: GetCompanyContactsPayload,
  auth: Authentication,
): Promise<CompanyContactsResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyContactsFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/contacts', payload, auth.token);

    return response.data as CompanyContactsResponse;
  } catch (e) {
    console.error('getCompanyContacts error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyContactsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyContactsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
